import { yupResolver } from '@hookform/resolvers/yup';
import { boolean, mixed, object, string } from 'yup';

import { fieldMax15, requiredField } from '~/ui/constants/errorMessages';

const MEDICAID_ID_MAX_LENGTH = 15;

const requiredWhenRecertificationRequired = (field = string()) =>
  field.when('isRecertificationRequired', {
    is: true,
    then: field.required(requiredField),
  });

export const medicaidPlanSchema = object().shape({
  medicaidTypeId: mixed(),
  medicaidId: requiredWhenRecertificationRequired(
    string().trim().max(MEDICAID_ID_MAX_LENGTH, fieldMax15),
  ),
  effectiveDate: string(),
  recertificationDate: requiredWhenRecertificationRequired(),
  isRecertificationRequired: boolean(),
});

export const medicaidPlanResolver = yupResolver(medicaidPlanSchema);
